import React, { useState } from "react";

// What each Wizetok role can do and see — opened from the (i) icon in
// Administration. Keep in step with utils/roleAccess.js (menus) and backend
// services/visibility.py + api/routes/admin_users.py (data and user rules).
const ROLES = [
  {
    name: "Admin",
    color: "#1B3A4B",
    can: [
      "Administration: add, edit and remove any Wizetok user in the company",
      "Assign any roles, including several to one person (and extra roles to themselves)",
      "Create and run positions, interviews and coding exams",
      "Settings",
    ],
    cannot: ["Remove their own Admin role or delete themselves"],
    data: "Sees every position, interview and report in the company.",
  },
  {
    name: "Manager",
    color: "#B8860B",
    can: [
      "Create and run positions, interviews and coding exams",
      "Add Recruiters to their team (Administration)",
      "Settings",
    ],
    cannot: ["Add Admins or Managers"],
    data: "Sees their own positions and those of the people they added (their team).",
  },
  {
    name: "Recruiter",
    color: "#22A06B",
    can: ["Create and run positions, interviews and coding exams", "Add Viewers (Administration)"],
    cannot: ["Settings", "Add Admins, Managers or Recruiters"],
    data: "Sees only their own positions.",
  },
  {
    name: "Viewer",
    color: "#6B7280",
    can: ["Open positions, interviews and reports in read-only mode"],
    cannot: ["Create, edit, upload or delete anything", "Administration and Settings"],
    data: "Read-only; sees only their own positions.",
  },
];

export default function RolePermissionsInfo() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        title="What can each role do?"
        aria-label="Role permissions"
        style={{
          width: 22, height: 22, borderRadius: "50%", border: "1.5px solid #6366F1", color: "#6366F1",
          background: "#fff", fontWeight: 700, fontSize: 13, fontStyle: "italic", fontFamily: "Georgia, serif",
          cursor: "pointer", lineHeight: "18px", padding: 0,
        }}
      >
        i
      </button>
      {open && (
        <div
          role="dialog"
          aria-modal="true"
          aria-label="Role permissions"
          onClick={() => setOpen(false)}
          style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,0.45)", zIndex: 2000,
                   display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{ background: "#fff", borderRadius: 12, maxWidth: 860, width: "100%", maxHeight: "88vh",
                     overflowY: "auto", padding: "20px 22px", color: "#111827" }}
          >
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6 }}>
              <h2 style={{ fontSize: 18, fontWeight: 700, margin: 0 }}>Wizetok role permissions</h2>
              <button type="button" onClick={() => setOpen(false)} aria-label="Close"
                style={{ background: "transparent", border: "none", cursor: "pointer", fontSize: 20, lineHeight: 1 }}>
                ×
              </button>
            </div>
            <p style={{ fontSize: 12, color: "#6B7280", margin: "0 0 14px" }}>
              A person can hold several roles; they get everything each role allows. Wizetok access is set
              separately from ReachOut, and Wizetok must be enabled for your company by the Service Provider.
            </p>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(190px, 1fr))", gap: 12 }}>
              {ROLES.map((r) => (
                <div key={r.name} style={{ border: "1px solid #E5E7EB", borderRadius: 10, padding: 12 }}>
                  <span style={{ display: "inline-block", fontSize: 12, fontWeight: 700, color: "#fff",
                                 background: r.color, borderRadius: 4, padding: "2px 8px" }}>{r.name}</span>
                  <div style={{ fontSize: 11, fontWeight: 700, color: "#15803D", margin: "10px 0 4px" }}>CAN</div>
                  <ul style={{ margin: 0, paddingLeft: 16, fontSize: 12, lineHeight: 1.5 }}>
                    {r.can.map((c) => <li key={c}>{c}</li>)}
                  </ul>
                  <div style={{ fontSize: 11, fontWeight: 700, color: "#B91C1C", margin: "10px 0 4px" }}>CANNOT</div>
                  <ul style={{ margin: 0, paddingLeft: 16, fontSize: 12, lineHeight: 1.5 }}>
                    {r.cannot.map((c) => <li key={c}>{c}</li>)}
                  </ul>
                  <div style={{ fontSize: 11, fontWeight: 700, color: "#374151", margin: "10px 0 4px" }}>DATA</div>
                  <div style={{ fontSize: 12, lineHeight: 1.5 }}>{r.data}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
